import { jsx as s } from "react/jsx-runtime";
import i, { createContext as l } from "react";
const e = l(void 0), c = (t) => {
  const { children: n, ...r } = t;
  return /* @__PURE__ */ s(e.Provider, { value: r, children: n });
};
function o() {
  return i.useContext(e);
}
function d() {
  const t = o();
  return !!(t != null && t.enableToolTipText);
}
function x() {
  const t = o();
  return !!(t != null && t.enableDisableWithTooltip);
}
export {
  e as FlagsContext,
  c as FlagsContextProvider,
  o as useFlagsContext,
  x as useIsDisabledWithTooltipEnabled,
  d as useIsToolTippedTextEnabled
};
//# sourceMappingURL=index.es590.js.map
